import config from '../config';
import selectedEnvironment from '../env';

const baseURL = config[selectedEnvironment].API_URL;
const ClientExpenseAssignment_API_URL = `${baseURL}/ClientExpenseAssignment`;

/**
 * Isolated "שיוך הוצאות" (Expense AccountCard assignment) API client.
 * Separate from Projects/Segmentation and from the Expenses/Update flow.
 */

/** Create/update (or clear, when accountCardId is null) the assignment for one expense. */
const updateAssignment = async ({ caseId, expenseId, accountCardId }, auth) => {
    return fetch(`${ClientExpenseAssignment_API_URL}/UpdateAssignment`, {
        method: 'PUT',
        headers: {
            Authorization: `Bearer ${auth}`,
            'Content-Type': 'application/json',
        },
        // camelCase matches ASP.NET Core default JSON binding
        body: JSON.stringify({
            caseId,
            expenseId,
            accountCardId: accountCardId != null && accountCardId !== '' ? String(accountCardId) : null,
        }),
    });
};

/** Current assignment for a single expense (used to prefill EditModal). */
const getByExpenseId = async (caseId, expenseId, auth) => {
    return fetch(
        `${ClientExpenseAssignment_API_URL}/ByExpenseId/${encodeURIComponent(caseId)}/${expenseId}`,
        {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${auth}`,
                'Content-Type': 'application/json',
            },
        }
    );
};

/** All expenses in the case that have a non-null AccountCard assignment. */
const getByCaseId = async (caseId, auth) => {
    return fetch(`${ClientExpenseAssignment_API_URL}/ByCaseId/${encodeURIComponent(caseId)}`, {
        method: 'GET',
        headers: {
            Authorization: `Bearer ${auth}`,
            'Content-Type': 'application/json',
        },
    });
};

const ClientExpenseAssignmentService = {
    updateAssignment,
    getByExpenseId,
    getByCaseId,
};

export default ClientExpenseAssignmentService;
